import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../../user/user-subscription";
import {UserSubscriptionStatus} from "../../../../user/user-subscription-status";
import {User} from "../../../../user/user";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import * as fromStore from '../../../../store';
import {Store} from "@ngrx/store";
import {getCurrencySymbol, isCurrencySymbol} from "../../../../shared/utils/currency-symbols";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-billing-info',
    templateUrl: './ds-billing-info.component.html',
    styleUrls: ['./ds-billing-info.component.scss'],
    standalone: false
})
export class DsBillingInfoComponent implements OnInit, OnDestroy {

  @Input() userSubscription: UserSubscription;
  @Input() annualSubscription: UserSubscription;
  @Input() monthlyPrice: number;
  @Input() annualPriceForCurrent: number;
  @Input() user: User;
  @Input() annualPrice: number;
  @Input() isTier1Country: boolean;
  public currencySymbol: string = '$';
  public isCurrencyBeforeAmount: boolean = true;
  public userSubscriptionStatus: typeof UserSubscriptionStatus = UserSubscriptionStatus;
  public UserSubscriptionType: typeof UserSubscriptionType = UserSubscriptionType;
  public UserSubscriptionCategory: typeof UserSubscriptionCategory = UserSubscriptionCategory;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  ngOnInit() {
      this._getCompanyInfo();
  }

    private _getCompanyInfo(): void {
        this._store.select(fromStore.getCompanyInfoLoaded)
            .pipe(
                filter((loaded: boolean) => loaded),
                switchMap(() => this._store.select(fromStore.getCompanyInfo)),
                takeUntil(this._destroyStream$)
            )
            .subscribe((companyInfo: any) => {
                this.currencySymbol = getCurrencySymbol(companyInfo?.agency?.currency);
                this.isCurrencyBeforeAmount = isCurrencySymbol(this.currencySymbol);
            });
    }

    ngOnDestroy(): void {
        this._destroyStream$.next(true);
        this._destroyStream$.complete();
    }
}
